import axios from 'axios';

export const getAllCategories = async (): Promise<unknown[]> => {
    const { data } = await axios.get(`/categories/all`);

    return data.data;
};
